<template>
  <div id="novelties" class="d-flex">
    <MainBarMenuV2 />
    <div class="header-top">
      <div class="container-fluid">
        <HeadingUser />
      </div>
    </div>
    <div class="layout-content container-fluid mt-5">
      <div class="row-center mt-5">
          <div class="col-xs-12">

          <div class="content-toggle">
                <div class="toggle-search">

          <button
                        type="button"
                        name="btn_Novedades"
                        class="btn_optionlogin"
                        @click="ActiveBtnNovedades"
                        :class="{ bn_active: activeBtn === 'Novedades' }"
                      >

                      <span class="cta ml-0" > Novedades</span>  <div  class="Novedades" v-if="getTotalNovedades > 0" >{{ getTotalNovedades }} </div>
                     
               </button>         
  
                      <button
                        type="button"
                        name="btnEntrenamientos"
                        class="btn_optionlogin"
                        @click="ActiveBtnEntrenamientos" 
                        :class="{ bn_active: activeBtn === 'Entrenamientos' }"
                      >
                        <span class="cta" > Entrenamientos</span>  <div  class="Novedades" v-if="getTotalEntrenamientos > 0">{{ getTotalEntrenamientos }} </div>
                      </button>
        </div>
          </div>

      <div v-if="activeBtn == 'Novedades' ">
        <p><Tipspayrollnews/></p>
      </div>
      <div v-if="activeBtn == 'Entrenamientos' " >
        <p><Training/></p>
      </div>
      <div v-if="activeBtn == 'Reemplazo extendido' " >
        <p><Trainingextended/></p>
      </div>
      <div class="col-12  mx-auto">
          <b-form-checkbox
            v-model="checkedExtended"
            name="check-button"
            switch
            size="lg"
          >
            ¿Requieres agregar un reemplazo extendido?
          </b-form-checkbox>
          <div class="row" v-if="checkedExtended">
            <TrainingextendedForm />
          </div>
        </div>
      </div>
      </div>
    </div>
</div>
  <!-- #page-onboarding -->
</template>

<script>
import MainBarMenuV2 from "../../components/layouts/MainBarMenuV2.vue";
import HeadingUser from "../../components/user/HeadingUser.vue";
import Tipspayrollnews from "../novelties/tipspayrollnews.vue";
import Training from "../payRollNews/training.vue";
//import  "@/assets/css/general.css";
import Trainingextended from "../payRollNews/trainingextended.vue";
import TrainingextendedForm from "../payRollNews/trainingextendedform.vue";
//import DeleteRow from "@/components/datatables/DeleteRow.vue";
export default {
  name: "novelties",
  components: {
    MainBarMenuV2,
    HeadingUser,
    Training,
    Trainingextended,
    Tipspayrollnews,
    TrainingextendedForm
  },
  data() {
    return {
      activeBtn:"Novedades",
      checkedExtended: true
    }
  },
  methods:{
  ActiveBtnNovedades() {
      this.activeBtn = "Novedades";
        
    },
  
    ActiveBtnEntrenamientos() {
      this.activeBtn = "Entrenamientos";
        
    }
}

}

</script>

<style lang="scss" scoped>
#novelties{

.nav-tabs{
        a{
            color:black;
            padding: 5px 15px;
        }
        a.active {
            background: rgba(38, 152, 135, 0.06);
            border-radius: 4px;
            border: 0;
            border-bottom: solid 3px;
            border-color: #269887;
    }
    a.active {
      background: rgba(38, 152, 135, 0.06);
      border-radius: 4px;
      border: 0;
      border-bottom: solid 3px;
      border-color: #269887;
    }
  }
}


 .content-toggle{
      /* _tab variants / horizontal */


/* Auto layout */
display: flex;
flex-direction: row;
align-items: flex-start;
padding-left: 40px;

border:none;
box-sizing: border-box;


position: static;
width: 376px;
height: 56px;
left: 28px;
top: 228px;


/* Inside auto layout */

flex: none;
order: 2;
flex-grow: 0;
margin: 30px 0px;


.Novedades{
/* Auto layout */

display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
padding: 2px;

position: static;
width: 16px;
height: 16px;
left: 128px;
top: 12px;

/* highlight/info/medium */

background: #0075FF;
border-radius: 100px;
font-family: 'Ubuntu';
font-style: normal;
font-weight: 500;
font-size: 10px;
line-height: 11px;
/* identical to box height */

display: flex;
align-items: center;
text-align: center;
color: #FFFFFF;

/* Inside auto layout */

flex: none;
order: 2;
flex-grow: 0;
margin: 0px 8px;
}    
.toggle-search{
        /* Auto layout */

display: flex;
flex-direction: row;
align-items: flex-start;
padding: 8px;

position: static;
left: 0%;
right: 0%;
top: 0%;
bottom: 0%;

/* CTA/00 */

background: #ECECFF;
/* CTA/01 */

border: 1px solid #C9CAFF;
box-sizing: border-box;
border-radius: 48px;

/* Inside auto layout */

flex: none;
order: 0;
flex-grow: 0;
margin: 0px 0px;
    }
    }


</style>